import { useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';
import ReactMarkdown from 'react-markdown';

function BlogDetail() {
  const { blogId } = useParams();
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        setLoading(true);
        const res = await axios.get(
          `https://qs9maczlpl.execute-api.ap-south-1.amazonaws.com/blogs`
        );
        const selectedBlog = res.data.find(b => b.blogId === blogId);
        
        if (selectedBlog) {
          setBlog(selectedBlog);
        } else {
          setError('Blog not found');
        }
      } catch (err) {
        setError('Failed to load blog');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [blogId]);

  if (loading) {
    return (
      <div className="min-h-screen bg-black text-white flex items-center justify-center overflow-hidden">
        <div className="fixed inset-0 -z-10">
          <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900"></div>
          <div className="absolute top-0 left-1/4 w-96 h-96 bg-purple-600 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob"></div>
          <div className="absolute top-0 right-1/4 w-96 h-96 bg-blue-600 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000"></div>
          <div className="absolute -bottom-8 left-1/2 w-96 h-96 bg-pink-600 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-4000"></div>
        </div>
        <div className="text-center relative z-10">
          <div className="animate-spin rounded-full h-16 w-16 border-2 border-purple-500/50 border-t-purple-500 mx-auto mb-6"></div>
          <p className="text-xl text-gray-300">Loading article...</p>
        </div>
      </div>
    );
  }

  if (error || !blog) {
    return (
      <div className="min-h-screen bg-black text-white overflow-hidden">
        <div className="fixed inset-0 -z-10">
          <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900"></div>
          <div className="absolute top-0 left-1/4 w-96 h-96 bg-purple-600 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob"></div>
          <div className="absolute top-0 right-1/4 w-96 h-96 bg-blue-600 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000"></div>
          <div className="absolute -bottom-8 left-1/2 w-96 h-96 bg-pink-600 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-4000"></div>
        </div>

        <header className="relative z-10 border-b border-white/10 backdrop-blur-md bg-black/30">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <button
              onClick={() => navigate('/')}
              className="inline-flex items-center gap-2 text-transparent bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text font-semibold hover:gap-3 transition-all"
            >
              ← Back to Home
            </button>
          </div>
        </header>

        <main className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <div className="backdrop-blur-xl bg-white/5 border border-white/10 rounded-3xl p-12 text-center">
            <p className="text-gray-300 text-lg mb-8">{error || 'Blog not found'}</p>
            <button
              onClick={() => navigate('/')}
              className="inline-flex items-center gap-2 px-8 py-3 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg font-semibold text-white hover:shadow-lg hover:shadow-purple-500/50 transition-all transform hover:scale-105"
            >
              ← Back to Home
            </button>
          </div>
        </main>

        <style jsx>{`
          @keyframes blob {
            0%, 100% { transform: translate(0, 0) scale(1); }
            33% { transform: translate(30px, -50px) scale(1.1); }
            66% { transform: translate(-20px, 20px) scale(0.9); }
          }
          .animate-blob {
            animation: blob 7s infinite;
          }
          .animation-delay-2000 {
            animation-delay: 2s;
          }
          .animation-delay-4000 {
            animation-delay: 4s;
          }
        `}</style>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black text-white overflow-hidden">
      {/* Animated background */}
      <div className="fixed inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900"></div>
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-purple-600 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob"></div>
        <div className="absolute top-0 right-1/4 w-96 h-96 bg-blue-600 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000"></div>
        <div className="absolute -bottom-8 left-1/2 w-96 h-96 bg-pink-600 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-4000"></div>
      </div>

      {/* Header */}
      <header className="relative z-10 border-b border-white/10 backdrop-blur-md bg-black/30">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex items-center justify-between">
          <h1 className="text-4xl font-black bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 bg-clip-text text-transparent">
            NAUSHER ALI
          </h1>
          <button
            onClick={() => navigate('/')}
            className="inline-flex items-center gap-2 px-6 py-2 bg-white/10 border border-white/20 rounded-lg text-white hover:bg-white/20 transition-all group"
          >
            Back
            
          </button>
        </div>
      </header>

      {/* Main Content */}
      <main className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Article */}
        <article className="backdrop-blur-xl bg-white/5 border border-white/10 rounded-3xl overflow-hidden">
          {/* Article Header */}
          <div className="bg-gradient-to-r from-blue-600/20 via-purple-600/20 to-pink-600/20 border-b border-white/10 p-8 md:p-12">
            <div className="max-w-3xl">
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
                {blog.title}
              </h1>
              <div className="flex items-center gap-4 text-gray-400">
                <span className="text-sm">📅 Published on {new Date(blog.timestamp || Date.now()).toLocaleDateString('en-US', {year: 'numeric', month: 'long', day: 'numeric'})}</span>
                <span className="w-1 h-1 bg-gray-500 rounded-full"></span>
                <span className="text-sm">📖 {blog.content.split(' ').length} words</span>
              </div>
            </div>
          </div>

          {/* Article Content */}
          <div className="p-8 md:p-12">
            <div className="max-w-3xl">
              <ReactMarkdown
                components={{
                  h1: ({node, ...props}) => <h1 className="text-4xl font-bold mt-10 mb-6 text-transparent bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text" {...props} />,
                  h2: ({node, ...props}) => <h2 className="text-3xl font-bold mt-10 mb-4 text-white border-b border-white/10 pb-3" {...props} />,
                  h3: ({node, ...props}) => <h3 className="text-2xl font-bold mt-8 mb-3 text-gray-100" {...props} />,
                  p: ({node, ...props}) => <p className="text-gray-300 leading-relaxed mb-6 text-base" {...props} />,
                  ul: ({node, ...props}) => <ul className="list-disc list-inside mb-6 text-gray-300 space-y-3" {...props} />,
                  ol: ({node, ...props}) => <ol className="list-decimal list-inside mb-6 text-gray-300 space-y-3" {...props} />,
                  li: ({node, ...props}) => <li className="text-gray-300" {...props} />,
                  blockquote: ({node, ...props}) => <blockquote className="border-l-4 border-purple-500 pl-6 italic text-gray-400 my-8 bg-white/5 py-4 pr-4 rounded-r-lg" {...props} />,
                  code: ({node, inline, ...props}) => 
                    inline ? 
                      <code className="bg-white/10 px-2 py-1 rounded text-sm font-mono text-cyan-400 border border-white/20" {...props} /> :
                      <code className="bg-black/50 text-gray-100 p-4 rounded-lg block overflow-x-auto font-mono text-sm my-6 border border-white/10" {...props} />,
                  pre: ({node, ...props}) => <pre className="bg-black/50 text-gray-100 p-4 rounded-lg overflow-x-auto my-6 border border-white/10" {...props} />,
                  a: ({node, ...props}) => <a className="text-blue-400 hover:text-blue-300 underline transition-colors" {...props} />,
                  img: ({node, ...props}) => <img className="max-w-full h-auto rounded-lg my-8 border border-white/10" {...props} />,
                  strong: ({node, ...props}) => <strong className="text-white font-bold" {...props} />,
                  em: ({node, ...props}) => <em className="text-gray-200 italic" {...props} />,
                }}
              >
                {blog.content}
              </ReactMarkdown>
            </div>
          </div>

          {/* Article Footer */}
          <div className="border-t border-white/10 bg-white/5 px-8 md:px-12 py-8 flex flex-col md:flex-row justify-between items-center gap-6">
            <button
              onClick={() => navigate('/')}
              className="group inline-flex items-center gap-3 px-8 py-3 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg font-semibold text-white hover:shadow-lg hover:shadow-purple-500/50 transition-all transform hover:scale-105"
            >
              ← Back to Articles
              <span className="group-hover:-translate-x-1 transition-transform">→</span>
            </button>
            <div className="flex gap-6 text-sm text-gray-400">
              <span>ID: {blog.blogId.substring(0, 8)}...</span>
              <span>Reading time: ~{Math.ceil(blog.content.split(' ').length / 200)}m</span>
            </div>
          </div>
        </article>

        {/* Related Articles Hint */}
        <div className="mt-16 text-center">
          <p className="text-gray-400 mb-6">Enjoy this article?</p>
          <button
            onClick={() => navigate('/')}
            className="inline-flex items-center gap-2 px-8 py-3 bg-white/10 border border-white/20 rounded-lg text-white hover:bg-white/20 transition-all"
          >
            ← Explore more articles
          </button>
        </div>
      </main>

      {/* Footer */}
      <footer className="relative z-10 border-t border-white/10 backdrop-blur-md bg-black/30 mt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 text-center">
          <p className="text-gray-400">© 2024 Nausher Ali | Software Engineer & Designer</p>
          <p className="text-gray-500 text-sm mt-2">Crafted with passion using React & Tailwind CSS</p>
        </div>
      </footer>

      <style jsx>{`
        @keyframes blob {
          0%, 100% { transform: translate(0, 0) scale(1); }
          33% { transform: translate(30px, -50px) scale(1.1); }
          66% { transform: translate(-20px, 20px) scale(0.9); }
        }
        .animate-blob {
          animation: blob 7s infinite;
        }
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        .animation-delay-4000 {
          animation-delay: 4s;
        }
      `}</style>
    </div>
  );
}

export default BlogDetail;
